import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  gridFilteredTopLevelRowCountSelector,
  gridPageCountSelector,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import { mobileWidth } from '@/constants/theme';
import { useLocalization } from '@/hooks/useLocalization';
import { getVaultPageRange } from './vaultPagination';

export const VaultPaginationFooter = () => {
  const { t } = useLocalization();
  const apiRef = useGridApiContext();
  const isMobile = useMediaQuery(mobileWidth);
  const { page, pageSize } = useGridSelector(
    apiRef,
    gridPaginationModelSelector,
  );
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const total = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);

  if (total === 0) return null;

  const { from, to } = getVaultPageRange({ page, pageSize, total });

  return (
    <Box
      component='nav'
      aria-label={t('documentVault.pagination.label')}
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        gap: 1,
        width: '100%',
        minWidth: 0,
        px: 2,
        py: 1,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Typography variant='body2'>
        {t('documentVault.pagination.showing', { from, to, count: total })}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant='body2'>
          {t('documentVault.pagination.total', { count: total })}
        </Typography>
        <IconButton
          size='small'
          aria-label={t('documentVault.pagination.previousPage')}
          disabled={page <= 0}
          onClick={() => {
            apiRef.current.setPage(page - 1);
          }}
        >
          <ChevronLeftIcon fontSize='small' />
        </IconButton>
        <IconButton
          size='small'
          aria-label={t('documentVault.pagination.nextPage')}
          disabled={page >= pageCount - 1}
          onClick={() => {
            apiRef.current.setPage(page + 1);
          }}
        >
          <ChevronRightIcon fontSize='small' />
        </IconButton>
      </Box>
    </Box>
  );
};
